import { FormatMessageType } from '@hooks/useValidation';
import { REQUIRED } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { HolodroneSensorConfiguration, SensorTypeEnum } from '@/types/sensor/sensors';

import {
  alertTimeoutThresholdSchemaValidation,
  commonSensorConfigurationSchemaValidation,
  hostSchemaValidation,
  portSchemaValidation,
} from './common.schema';

export function holodroneSchemaValidation(
  formatMessage: FormatMessageType,
): Yup.ObjectSchema<Partial<HolodroneSensorConfiguration>> {
  return commonSensorConfigurationSchemaValidation(formatMessage)
    .concat(alertTimeoutThresholdSchemaValidation(formatMessage))
    .shape({
      type: Yup.mixed<SensorTypeEnum>()
        .oneOf([SensorTypeEnum.HOLODRONE], formatMessage({ id: REQUIRED }))
        .required(formatMessage({ id: REQUIRED })),
      holodroneId: Yup.number().required(formatMessage({ id: REQUIRED })),
      host: hostSchemaValidation(formatMessage),
      port: portSchemaValidation(formatMessage),
      grpcPort: portSchemaValidation(formatMessage).when('grpcMode', {
        is: true,
        then: (schema) => schema.required(formatMessage({ id: REQUIRED })),
        otherwise: (schema) => schema.notRequired(),
      }),
      timeOverload: Yup.boolean().required(formatMessage({ id: REQUIRED })),
      apiKey: Yup.string().when('grpcMode', {
        is: true,
        then: (schema) => schema.required(formatMessage({ id: REQUIRED })),
        otherwise: (schema) => schema.notRequired(),
      }),
    }) as Yup.ObjectSchema<Partial<HolodroneSensorConfiguration>>;
}
